var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavbarView'),_c('router-view'),_c('TapTop'),_c('FooterView'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-badge"},[_c('div',{staticClass:"text-container"},[_vm._v("Pay with")]),_c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":require("@/assets/jazz-cash.png"),"alt":""}})])])
}]

export { render, staticRenderFns }